import { handle420 } from 'apis/HandleError';
import { apiConfig } from 'config';

const STATUS_CHECK_INTERVAL_MS = process.env.NODE_ENV !== 'test' ? 2000 : 10;

const checkResponse = (url, data, resolve, reject) => {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  if (data == null) {
    fetch(url, { headers: headers, method: 'GET' })
      .then((result) => {
        result.json().then((jsonData) => checkResponse(url, jsonData, resolve, reject));
      })
      .catch((error) => console.log(error));
    return;
  }
  console.log(data.runtimeStatus);
  if (data.runtimeStatus !== 'Pending' && data.runtimeStatus !== 'Running') {
    //TODO perform an action
    //console.log("DONE! Data:", data);
    resolve(data);
    return;
  }

  setTimeout(function () {
    fetch(url, { headers: headers, method: 'GET' }).then((result) => {
      result.json().then((jsonData) => {
        checkResponse(url, jsonData, resolve, reject);
      });
    });
  }, STATUS_CHECK_INTERVAL_MS);
};

export function setWifi(id, targetStatus, targetSSID, targetPSK, targetEnableTimer, targetDisableTimer, retry = true) {
  const auth = window.__APP_AUTH;
  const headers = {
    Accept: '*/*',
    'cache-control': 'no-cache',
    Authorization: 'Bearer ' + auth?.accessToken,
    'accept-encoding': 'gzip, deflate'
  };

  let postBody = {
    ...(targetStatus && { status: targetStatus }),
    ...(targetSSID && { ssid: targetSSID }),
    ...(targetPSK && { psk: targetPSK }),
    ...(targetEnableTimer != null && { enableTimer: Number(targetEnableTimer) }),
    ...(targetDisableTimer != null && { disableTimer: Number(targetDisableTimer) })
  };

  return new Promise((resolve, reject) => {
    let url = apiConfig.cmServiceDevicesSetWifi(id);
    fetch(url, { headers: headers, method: 'POST', body: JSON.stringify(postBody) })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            console.log('Set wifi response:', data);
            let url = data.statusQueryGetUri; //data.statusQueryGetUri.substring(data.statusQueryGetUri.search("/runtime/webhooks/durabletask/instances"));
            checkResponse(url, null, resolve, reject);
          });
        } else {
          //throw new Error();
          return response.text().then((x) => {
            throw new Error(x);
          });
        }
      })
      .catch((e) => {
        console.log('lock/unlock error = ' + e.message);
        switch (e.message) {
          case '420':
            const auth = window.__APP_AUTH;
            if (auth && retry) {
              return auth.renewSession().then(() => {
                return setWifi(
                  id,
                  targetStatus,
                  targetSSID,
                  targetPSK,
                  targetEnableTimer,
                  targetDisableTimer,
                  (retry = false)
                );
              });
            } else {
              handle420();
            }
            break;
          default:
            reject(e);
        }
        return;
      });
  });
}
